import type { Dispatch } from 'react';
import { Button, ButtonRow } from '@ksyos/design-system';
import type {
    AdminProcessesListAlertsState,
    IAdminProcess,
    NewOrOldAdminProcess,
    ShowModalType,
} from '@frontend/components/interfaces/adminProcessesList';
import { getSelectedLanguage } from '@frontend/translate';
import type { ReactPartialDispatch } from '../../../../utils/hooks/useStateWithPartialSet';
import { RequestStatus } from '../../../../../common/enums/requestStatus';
import { canChangeCareProvider } from '../../../../utils/canChangeCareProvider';

interface IAdminProcessesFooterButtonsProps {
    alerts: AdminProcessesListAlertsState;
    loadSucceedingConsultation: (processId?: string) => void;
    processes: NewOrOldAdminProcess[];
    setAlerts: ReactPartialDispatch<AdminProcessesListAlertsState>;
    setShowModal: Dispatch<ShowModalType>;
}

export function AdminProcessesFooterButtons(props: IAdminProcessesFooterButtonsProps) {
    const language = getSelectedLanguage();
    const checkedProcesses = getCheckedProcesses();

    return (
        <ButtonRow sx={{ marginTop: 8 }}>
            <Button
                color="secondary"
                isDisabled={checkedProcesses.length !== 1 || !canChangeCareProvider(checkedProcesses[0])}
                onClick={async () => props.setShowModal('changeCareprovider')}
                variant="outline"
            >
                {language.request.assignOther}
            </Button>
            <Button
                color="secondary"
                isDisabled={checkedProcesses.length === 0}
                onClick={() => props.setShowModal('closeProcess')}
                variant="outline"
            >
                {language.request.closeProcess}
            </Button>
            <Button
                color="secondary"
                isDisabled={
                    checkedProcesses.length !== 1 ||
                    checkedProcesses[0].status === RequestStatus.aborted ||
                    checkedProcesses[0].status === RequestStatus.cancelled
                }
                onClick={() => {
                    props.setShowModal('abortProcess');
                    props.loadSucceedingConsultation(checkedProcesses[0].succeedingConsultationId);
                }}
                variant="outline"
            >
                {language.request.abortProcess}
            </Button>
            {checkedProcesses.length === 1 && checkedProcesses[0].status === RequestStatus.withAdmin && (
                <Button
                    color="secondary"
                    onClick={async () => props.setShowModal('checkGeneralPractitioner')}
                    variant="outline"
                >
                    {language.request.checkGeneralPractitioner}
                </Button>
            )}
        </ButtonRow>
    );

    function getCheckedProcesses() {
        return props.processes.filter((process) => process.processId && process.checked === true) as IAdminProcess[];
    }
}
